"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ng_redux_1 = require("./components/ng-redux");
var root_store_1 = require("./components/root-store");
var dev_tools_1 = require("./components/dev-tools");
/** @hidden */
function _ngReduxFactory(ngZone) {
    return new root_store_1.RootStore(ngZone);
}
exports._ngReduxFactory = _ngReduxFactory;
var NgReduxModule = (function () {
    function NgReduxModule() {
    }
    NgReduxModule.decorators = [
        { type: core_1.NgModule, args: [{
                    providers: [
                        dev_tools_1.DevToolsExtension,
                        { provide: ng_redux_1.NgRedux, useFactory: _ngReduxFactory, deps: [core_1.NgZone] }
                    ]
                },] },
    ];
    /** @nocollapse */
    NgReduxModule.ctorParameters = function () { return []; };
    return NgReduxModule;
}());
exports.NgReduxModule = NgReduxModule;
;
//# sourceMappingURL=ng-redux.module.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/@angular-redux/store/lib/src/ng-redux.module.js
// module id = ../../../../@angular-redux/store/lib/src/ng-redux.module.js
// module chunks = 13